import React from 'react';
export function LemonSlice({
  className,
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return <svg viewBox="0 0 100 100" className={className} style={style} fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-40">
      <circle cx="50" cy="50" r="45" fill="currentColor" opacity="0.2" data-id="element-41" />
      <circle cx="50" cy="50" r="40" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.5" data-id="element-42" />
      <path d="M50 10L50 45M90 50L55 50M50 90L50 55M10 50L45 50M22 22L43 43M78 22L57 43M78 78L57 57M22 78L43 57" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.6" data-id="element-43" />
      <circle cx="50" cy="50" r="5" fill="currentColor" opacity="0.8" data-id="element-44" />
    </svg>;
}